import { createBrowserRouter, Navigate, RouteObject } from "react-router-dom";
import ActivityDashboard from "../../features/activities/dashboard/ActivityDashboard";
import ActivityDetails from "../../features/activities/details/ActivityDetails";
import ActivityForm from "../../features/activities/form/ActivityForm";
import NotFound from "../../features/errors/NotFound";
import ServerError from "../../features/errors/ServerError";
import TestErrors from "../../features/errors/TestError";
import ProfilePage from "../../features/profiles/ProfilePage";
import App from "../layout/App";
import RequireAuth from "./RequireAuth";
import TrendyDashboardProjectsPage from "../../features/home/TrendyDashboardProjectsPage";
import TrendyDashboardServicesPage from "../../features/home/TrendyDashboardServicesPage";
import TrendyDashboardContactUsPage from "../../features/home/TrendyDashboardContactUsPage";
import TrendyDashboardAboutUsPage from "../../features/home/TrendyDashboardAboutUsPage";
import TrendyDashboardHotelManagementPage from "../../features/home/TrendyDashboardHotelManagementPage";
import TrendyDashboardStoreManagementPage from "../../features/home/TrendyDashboardStoreManagementPage";
import TrendyDashboardPharmacyManagementPage from "../../features/home/TrendyDashboardPharmacyManagementPage";
import TrendyDashboardOfficeManagementPage from "../../features/home/TrendyDashboardOfficeManagementPage";
import TrendyDashboardDairyManagementPage from "../../features/home/TrendyDashboardDairyManagementPage";
import WebHomePage from "../../features/home/WebHomePage";
import HomePage from "../../features/home/HomePage";
import ResponsiveTrendyHomePage from "../../features/home/ResponsiveTrendyHomePage";

export const routes: RouteObject[] = [
    // {
    //     path: '/',
    //     element: <App />,
    //     children: [
    //         {element: <RequireAuth />, children: [
    //             // {path: 'activities', element: <ActivityDashboard />},
    //             // {path: 'activities/:id', element: <ActivityDetails />},
    //             // {path: 'createActivity', element: <ActivityForm key='create' />},
    //             // {path: 'manage/:id', element: <ActivityForm key='manage' />},
    //             // {path: 'profiles/:username', element: <ProfilePage />},
    //             // {path: '/projects', element: <TrendyDashboardProjectsPage />},
    //             // {path: '/services', element: <TrendyDashboardServicesPage />},
    //             // {path: '/contactus', element: <TrendyDashboardContactUsPage />},
    //             // {path: '/aboutus', element: <TrendyDashboardAboutUsPage />},
    //             // {path: '/hotelmanagementsystem', element: <TrendyDashboardHotelManagementPage />},
    //             // {path: '/storemanagementsystem', element: <TrendyDashboardStoreManagementPage />},
    //             // {path: '/pharmacymanagementsystem', element: <TrendyDashboardPharmacyManagementPage />},
    //             // {path: '/officemanagementsystem', element: <TrendyDashboardOfficeManagementPage />},
    //             // {path: '/dairymanagementsystem', element: <TrendyDashboardDairyManagementPage />},
    //             {path: 'errors', element: <TestErrors />}
    //         ]},                        
    //         {path: 'not-found', element: <NotFound />},
    //         {path: 'server-error', element: <ServerError />},
    //         {path: '*', element: <Navigate replace to='/not-found' />},
    //     ]
    // },
    {
        path:'/',
        element: <App />
    }
    //,
    // {
    //     path:'/projects',
    // //     element: <TrendyDashboardProjectsPage />
    // element: <App />
    //  },
    // {
    //     path:'/services',
    //     // element: <TrendyDashboardServicesPage />
    //     element: <App />
    // },
    // {
    //     path:'contactus',
    //     element: <TrendyDashboardContactUsPage />
    //     //element: <App />
    // },
    // {
    //     path:'/aboutus',
    //     // element: <TrendyDashboardAboutUsPage />
    //     element: <App />
    // },
    // {
    //     path:'/hotelmanagementsystem',
    //     // element: <TrendyDashboardHotelManagementPage />
    //      element: <App />
    // },
    // {
    //     path:'/storemanagementsystem',
    //     // element: <TrendyDashboardStoreManagementPage />
    //     element: <App />
    // },
    // {
    //     path:'/pharmacymanagementsystem',
    //     // element: <TrendyDashboardPharmacyManagementPage />
    //     element: <App />
    // },
    // {
    //     path:'/officemanagementsystem',
    //     // element: <TrendyDashboardOfficeManagementPage />
    //     element: <App />
    // },
    // {
    //     path:'/dairymanagementsystem',
    //     // element: <TrendyDashboardDairyManagementPage />
    //     element: <App />
    // }
]

export const router = createBrowserRouter(routes);